import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import HostedPage from './components/hosted-page'
import { getSentryEnvKey } from './config/config'
import SdkPage from './components/sdk-page/SdkPageWithTimeout'
import packageJson from '../package.json'

import './assets/main.css'
import './index.scss'
import './App.css'
import Receipt from './components/receipt'

const baseUri = window.env.REACT_APP_DEMO_BASE_URI

// Get version from package.json
const version = process.env.REACT_APP_VERSION || packageJson.version
console.info('sdk-hpp-fe v' + version)

const router = createBrowserRouter(
    [
        {
            path: '/sdk/:id',
            element: <SdkPage />,
        },
        {
            path: '/',
            element: <HostedPage />,
        },
        {
            path: '/:data',
            element: <HostedPage />,
        },
        {
            path: '/payment/receipt',
            element: <Receipt />,
        },
    ],
    {
        basename: baseUri,
        future: {
            v7_startTransition: true,
        },
    },
)

Sentry.init({
    environment: getSentryEnvKey(),
    dsn: 'https://ec10b630d83943c6d8bfca3eb807faa0@o4505706145775616.ingest.sentry.io/4506538308468736',
    integrations: [
        new Sentry.BrowserTracing({
            tracePropagationTargets: ['localhost', /^https:\/\/[a-z-]+\.hosted-page\.ecomm-[A-Za-z0-9]+\.dmgsecure\.io/],
        }),
    ],
    tracesSampleRate: 1.0,
})

ReactDOM.createRoot(document.getElementById('root')).render(
    <RouterProvider router={router} future={{ v7_startTransition: true }} />,
)
